const normalizeVehicleNumber = (value: string): string =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, 10);

export const formatVehicleNumber = (value: string): string => {
  const cleaned = normalizeVehicleNumber(value);

  // BH series: 22BH1234AA
  if (/^\d{0,2}BH/i.test(cleaned)) {
    const year = cleaned.slice(0, 2);
    const bh = cleaned.slice(2, 4);
    const number = cleaned.slice(4, 8);
    const series = cleaned.slice(8, 10);

    return [year, bh, number, series].filter(Boolean).join(" ");
  }

  // Standard format: MH18BR5656
  const state = cleaned.slice(0, 2);
  const rto = cleaned.slice(2, 4);
  const series = cleaned.slice(4, 6);
  const number = cleaned.slice(6, 10);

  return [state, rto, series, number].filter(Boolean).join(" ");
};

export const isValidIndianVehicleNumber = (value: string): boolean => {
  const normalized = normalizeVehicleNumber(value);

  const bhSeriesPattern = /^\d{2}BH\d{4}[A-Z]{2}$/;
  const standardPattern = /^[A-Z]{2}\d{1,2}[A-Z]{1,2}\d{4}$/;

  return bhSeriesPattern.test(normalized) || standardPattern.test(normalized);
};
